module.exports = __webpack_public_path__ + "img/A5.21e5266f.svg";